













































import Vue from "vue";
import WeatherIcon from "./WeatherIcon.vue";
import Forecast from "./Forecast.vue";
import axios from "axios";

export default Vue.extend({
  props: ["city"],
  data: () => ({
    forecasts: [] as any,
    currentForecastIndex: 0
  }),
  components: {
    WeatherIcon,
    Forecast
  },
  created() {
    this.getForecast();
  },
  watch: {
    city() {
      this.getForecast();
    }
  },
  methods: {
    getForecast() {
      axios
        .get(
          process.env.VUE_APP_FORECAST_API +
            this.city.name +
            "&units=metric" +
            "&appid=" +
            process.env.VUE_APP_WEATHER_API_KEY
        )
        .then(response => {
          if (response.data.cod === 429) {
            this.$toasted.info(
              "API requests for this subscription have been exceeded"
            );
          } else {
            this.prepareForecast(response.data.list);
          }
        })
        .catch(error => {
          this.$toasted.error("Forecast not available");
        });
    },

    prepareForecast(forecasts: any[]) {
      const availableDates: any[] = [];

      forecasts.forEach(forecast => {
        const date = forecast.dt_txt.split(" ")[0];
        const found = availableDates.find(f => f.date === date);

        if (found) {
          found.data.push(forecast);
        } else {
          availableDates.push({
            date,
            data: [forecast]
          });
        }
      });

      if (availableDates[0].data.length === 1) {
        availableDates.shift();
      }
      this.forecasts = availableDates;
    }
  }
});
